import {useSuggestCategorizationsQuery} from '@transactions/graphql';
import type {BasicRawTransactionFragment} from '@transactions/graphql';

/**
 * Asks history about every row the card shows, in one request, and shows
 * none of it: the answer is cached per row (see apolloCache/suggestions), so
 * a row tapped into the create sheet opens already prefilled.
 */
export const usePrefetchSuggestions = (rows: BasicRawTransactionFragment[]) => {
  const ids = rows.map((row) => row._id);
  useSuggestCategorizationsQuery({
    variables: {rawTransactionIds: ids},
    skip: ids.length === 0,
    // History moves as rows are categorized anywhere in the app, so each
    // visit asks again rather than trusting what an earlier one cached.
    fetchPolicy: 'cache-and-network',
  });
};
